<maple-header class="maple-header">
  <a href="{ baseUrl }" class="maple-header__logo" />
  <a href="{ baseUrl }" class="maple-header__help-link">Create your own map!</a>

  <script>
    import { STORE } from '~/events.js'

    export default {
      baseUrl: STORE.baseUrl
    }
  </script>
</maple-header>
